<template>
  <div class="config">
    <el-row>
      <el-col :span="24">
        <button-select v-model="btnValue" :btns="btns" @input="buttonSelect" />
      </el-col>
    </el-row>
    <el-row class="config-transfer">
      <el-col :span="24">
        <zl-transfer v-model="transferValue" :data="transferList" :titles="title" :props="props" @change="transferChange" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ButtonSelect from '@/components/select/button-select/button-select'
import { getAllSuppClass, getAllSupplierByFormula } from '@/api/achievements'
export default {
  components: { ButtonSelect },
  props: {
    // eslint-disable-next-line
    value: {},
    // eslint-disable-next-line
    data: {}
  },
  data() {
    return {
      props: {
        key: 'index',
        label: 'supOfficeName',
        disabled: 'disabled'
      },
      transferList: [],
      transferValue: [],
      btns: [],
      btnValue: '',
      formulaId: '',
      purchaseUnitNo: ''
    }
  },
  computed: {
    title() {
      return this.$t('performance.formulaConfig.transferTitle')
    },
    transferMap() {
      const key = this.props.key
      return this.transferList.reduce((o, cur) => (o[cur[key]] = cur) && o, {})
    },
    id() {
      return this.$route.params.id
    },
    computedValue() {
      return this.transferValue.map(item => ({ supOfficeNo: this.transferMap[item].supOfficeNo, id: parseInt(this.transferMap[item].id) }))
    }
  },
  watch: {
    'data.purOfficeNo': {
      handler() {
        this.btnValue = ''
        this.buttonSelect()
      },
      deep: true
    }
  },
  async created() {
    this.btns = await getAllSuppClass(this.id)
    await this.buttonSelect()
    this.transferValue = this.getCheckedList()
    this.transferChange()
  },
  methods: {
    async buttonSelect(value = '') {
      const { purOfficeNo } = this.data
      const list = await getAllSupplierByFormula(value, this.id, purOfficeNo)
      this.transferList = list.map((item, index) => ({ ...item, index }))
      this.transferValue = []
    },
    transferChange() {
      this.$emit('input', this.computedValue)
    },
    getCheckedList() {
      return this.transferList.filter(item => item.checked).map(item => item.index)
    }
  }
}
</script>

<style lang="scss" scoped>
.config {
  &-transfer {
    margin-top: 20px;
  }
}
</style>
